<template>
    <div>
        <div class="loading"><i class="iconfont">&#xe627;</i></div>
    </div>
</template>
<script>
import API from "@/api/config";
export default{
    mounted(){
        API.Web.LoginStatus().then(resStatus => {
            if (resStatus.Code==0&&resStatus.Data) {
                if(resStatus.Data.RightsList.length>0){
                    let obj = resStatus.Data.RightsList.find(f=>f.RightsCode=='JZX');
                    if(obj){
                        API.Web.GankaoSingleLogin().then(res => {
                            if(res.Code==0&&res.Data){
                                let st2 = setTimeout(()=>{
                                    window.location.href=res.Data;
                                    clearTimeout(st2);
                                },50)
                            }
                            else{
                                this.$message.info(res.Message);
                            }
                        }).catch(err => {
                        })
                    }
                    else{
                        this.$router.push('/openvip?productCode=JZX-GZ-3');
                    }
                }
                else{
                    this.$router.push('/openvip?productCode=JZX-GZ-3');
                }
            }
            else{
                this.$router.push('/login');
            }
        })
    }
}
</script>
<style scoped lang="less">
.loading{
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: #fff;
	text-align: center;
	.iconfont{
		color: #dfdede;
		font-size: 40px;
        display: block;
        position: absolute;
        left: calc(50% - 20px);
        top: calc(50% - 20px);
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        z-index: 1;
        animation:loadiing 1s linear 0s infinite;
        -webkit-animation:loadiing 1s linear 0s infinite;
	}
    @-webkit-keyframes loadiing {
        from {-webkit-transform: rotate(0deg);transform: rotate(0deg);}
        to {-webkit-transform: rotate(360deg);transform: rotate(360deg);}
    }
    @keyframes loadiing {
        from {-webkit-transform: rotate(0deg);transform: rotate(0deg);}
        to {-webkit-transform: rotate(360deg);transform: rotate(360deg);}
    }
}

</style>